(ns global.endor.checkout.stripe.config
  (:require [global.endor.checkout.config :as config]
            [clojure.string :as str]))

(def config
  (if (or config/DEV_MODE
          (str/includes? (.-host js/location) "staging"))
    {:publishable-key "pk_test_51RZYVg4YgeMg9gxWAU65QwrLcyCUkqRUp90TYZXspn81Zc2nRreqJJXPLgtz2jLJT7jJsE8KkjgPIFqeaubgdGYg00BRX7QUVt"
     :prices {:yearly-subscription "price_1SXKGM4YgeMg9gxWIc8A7khd"
              :monthly-subscription "price_1S663c4YgeMg9gxWdbvVDhfo"}}
    {:publishable-key "pk_live_51RZYVaGHDJjE1LpSK2whbRTUkxusbCQdSwEzxYixtmIDZkNRL7yymK4a1zvEmXx7ZnzYjdbhN4wM3zuwAeSNSR3V00hLKGc42r"
     :prices {:yearly-subscription "price_1SXKIgGHDJjE1LpSUZ8TgJgt"
              :monthly-subscription "price_1S55s5GHDJjE1LpS4cYlkNb6"}}))
